import * as _Tea from './index';
export const Tea = _Tea;
